import React from "react";
import "./Contact.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { useState } from "react";
import { themeContext } from "../../Context";
import { useContext } from "react";

const Contact = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
   const form = useRef();

   const [done, setdone] =useState(false)
   const sendEmail = (e) => {
     e.preventDefault();

     emailjs
       .sendForm(
         "service_dcpu319",
         "template_lmtauq5",
         form.current,
         "Qvy_CbZJTdegE5F6A"
       )
       .then(
         (result) => {
           console.log(result.text);
           setdone(true)
         },
         (error) => {
           console.log(error.text);
         }
       );
   };
  return (
    <div className="c-form">
      <div className="w-left">
        <div className="awesome">
          <span style={{ color: darkMode ? "white" : "" }}>Get in touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#abf1ff94" }}
          ></div>
        </div>
      </div>
      <div className="c-right">
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Name"
          />
          <input
            type="email"
            name="user_email"
            className="user"
            placeholder="Email"
          />
          <textarea name="message" className="user" placeholder="Messsage" />
          <input type="submit" value="Send" className="button" />
          <span>{done && "Thanks for the Holla!"}</span>
          <div
            className="blur c-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
